import { createTheme } from "@mui/material";
import { typography } from "./typography";
import { shadows } from "./shadows";
import { shape } from "./shape";
import { breakpoints } from "./breakpoints";
import { palette } from "./palette";
import { MuiAlert } from "../MuiComponents/Alert/Alert";
import { MuiAutocomplete } from "../MuiComponents/Autocomplete/Autocomplete";
import { MuiAvatar } from "../MuiComponents/Avatar/Avatar";
import { MuiBadge } from "../MuiComponents/Badge/Badge";
import { MuiButton } from "../MuiComponents/Button/Button";
import { MuiChip } from "../MuiComponents/Chip/Chip";
import { MuiDialog } from "../MuiComponents/Dialog/Dialog";
import { MuiDialogTitle } from "../MuiComponents/Dialog/DialogTitle";
import { MuiDialogActions } from "../MuiComponents/Dialog/DialogActions";
import { MuiDivider } from "../MuiComponents/Divider/Divider";
import { MuiFormHelperText } from "../MuiComponents/Form/FormHelperText";
import { MuiIconButton } from "../MuiComponents/IconButton/IconButton";
import { MuiInput } from "../MuiComponents/Input/Input";
import { MuiInputLabel } from "../MuiComponents/Input/InputLabel";
import { MuiLink } from "../MuiComponents/Link/Link";
import { MuiListItemAvatar } from "../MuiComponents/List/ListItemAvatar";
import { MuiOutlinedInput } from "../MuiComponents/Input/OutlinedInput";
import { MuiTableCell } from "../MuiComponents/Table/TableCell";
import { MuiTableRow } from "../MuiComponents/Table/TableRow";
import { MuiTab } from "../MuiComponents/Tabs/Tab";
import { MuiTabs } from "../MuiComponents/Tabs/Tabs";
import { MuiToolbar } from "../MuiComponents/Toolbar/Toolbar";
import { MuiTooltip } from "../MuiComponents/Tooltip/Tooltip";
import { MuiSelect } from "../MuiComponents/Select/Select";
import { MuiMenu } from "../MuiComponents/Menu/Menu";
import { MuiCheckbox } from "../MuiComponents/Checkbox/Checkbox";
import { MuiDialogContent } from "../MuiComponents/Dialog/DialogContent";
import { MuiLinearProgress } from "../MuiComponents/LinearProgress/LinearProgress";
import { MuiSvgIcon } from "../MuiComponents/SvgIcon/SvgIcon";
import { MuiTextField } from "../MuiComponents/TextField/TextField";
import { MuiListItemButton } from "../MuiComponents/List/ListItemButton";
import { MuiListItemText } from "../MuiComponents/List/ListItemText";
import { MuiListItemIcon } from "../MuiComponents/List/ListItemIcon";
import { MuiToggleButton } from "../MuiComponents/ToggleButton/ToggleButton";
import { MuiInputBase } from "../MuiComponents/Input/InputBase";
import { MuiCircularProgress } from "../MuiComponents/CircularProgress/CircularProgress";
import { MuiSkeleton } from "../MuiComponents/Skeleton/Skeleton";
import { MuiAppBar } from "../MuiComponents/AppBar/AppBar";
export const truffleTheme = createTheme({
    palette,
    shape,
    typography,
    shadows,
    components: {
        MuiAlert,
        MuiAppBar,
        MuiAutocomplete,
        MuiAvatar,
        MuiBadge,
        MuiButton,
        MuiCheckbox,
        MuiChip,
        MuiCircularProgress,
        MuiDialog,
        MuiDialogTitle,
        MuiDialogContent,
        MuiDialogActions,
        MuiDivider,
        MuiFormHelperText,
        MuiIconButton,
        MuiInput,
        MuiInputLabel,
        MuiLinearProgress,
        MuiLink,
        MuiListItemText,
        MuiListItemButton,
        MuiListItemIcon,
        MuiListItemAvatar,
        MuiOutlinedInput,
        MuiTableCell,
        MuiTableRow,
        MuiTab,
        MuiTabs,
        MuiToolbar,
        MuiTooltip,
        MuiSelect,
        MuiSvgIcon,
        MuiMenu,
        MuiTextField,
        MuiToggleButton,
        MuiInputBase,
        MuiSkeleton
    },
    breakpoints
});
//# sourceMappingURL=theme.js.map